import { GaugeChartValue } from './GaugeChartBase';

export type GaugeSeries = {
  value: GaugeChartValue;
  label: string;
};

// Thresholds going into ECharts Gauge are defined as  GREATER than
// Our thresholds are defined as GREATER THAN OR EQUAL TO
// So to go from less than to less than equal to, we will subtract a small
// amount (epsilon) from every step value. We define and export it as a constant here
// so that it can be used elsewhere consistently
// Example: If the step is greater than equal to 1
// we give it to echarts as greater than 0.999999
export const GAUGE_CHART_EPSILON = 0.000001;
